import React from "react";
import { SectionCard } from "../scraper";

const STAT_CONFIG = [
    {
        key: "total_campaigns",
        title: "Total Campaigns",
        icon: "📣",
        color: "text-blue-600",
        bg: "bg-blue-50",
        border: "border-blue-100",
    },
    {
        key: "total_emails",
        title: "Total Emails",
        icon: "✉️",
        color: "text-indigo-600",
        bg: "bg-indigo-50",
        border: "border-indigo-100",
    },
    {
        key: "success_emails",
        title: "Delivered",
        icon: "✅",
        color: "text-green-600",
        bg: "bg-green-50",
        border: "border-green-100",
    },
    {
        key: "failed_emails",
        title: "Failed",
        icon: "❌",
        color: "text-red-500",
        bg: "bg-red-50",
        border: "border-red-100",
    },
    {
        key: "success_rate",
        title: "Success Rate",
        icon: "📈",
        color: "text-violet-600",
        bg: "bg-violet-50",
        border: "border-violet-100",
        suffix: "%",
    },
    {
        key: "attachments_sent",
        title: "Attachments",
        icon: "📎",
        color: "text-purple-600",
        bg: "bg-purple-50",
        border: "border-purple-100",
    },
    {
        key: "campaigns_last_30_days",
        title: "Campaigns (30d)",
        icon: "🗓️",
        color: "text-orange-500",
        bg: "bg-orange-50",
        border: "border-orange-100",
    },
    {
        key: "emails_last_30_days",
        title: "Emails (30d)",
        icon: "📬",
        color: "text-cyan-600",
        bg: "bg-cyan-50",
        border: "border-cyan-100",
    },
];

const StatCard = ({ title, value, icon, color, bg, border, suffix = "" }) => (
    <div className={`rounded-xl border ${border} ${bg} p-4 flex items-start gap-3`}>
        <div className="text-xl leading-none mt-0.5">{icon}</div>
        <div className="min-w-0">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide truncate">
                {title}
            </p>
            <p className={`text-2xl font-bold mt-1 ${color} leading-none`}>
                {value ?? "—"}{suffix}
            </p>
        </div>
    </div>
);

const DashboardStats = ({ dashboard }) => {
    if (!dashboard) return null;

    return (
        <SectionCard title="Overview">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {STAT_CONFIG.map((cfg) => (
                    <StatCard
                        key={cfg.key}
                        title={cfg.title}
                        value={dashboard[cfg.key]}
                        icon={cfg.icon}
                        color={cfg.color}
                        bg={cfg.bg}
                        border={cfg.border}
                        suffix={cfg.suffix}
                    />
                ))}
            </div>
        </SectionCard>
    );
};

export default DashboardStats;